import { routeToDashboard } from "@/helpers/routing"

export default function ({ $auth, redirect }) {
    let user = $auth.user

    if (user?.business && user.business.slug !== "oabat") {
        redirect(routeToDashboard(user))
    }
}
